
import { MedicineModel } from "../../models/pharmacy/medicine.model";
import { ProductCodeStruct } from "./product-code.struct";
import { StorageAmountLocationStruct } from "./storage-amount-location.struct";

export class StorageStruct {
    public storageAmountLocation: StorageAmountLocationStruct;
    public productCode: ProductCodeStruct;
    public medicine: MedicineModel;

    public idStorage: number;
    public idMedicine: number;
    public idItem: number;
    public batch: number;
    public idMedicinePresentationType: number;
    public unitValue: number;
    public idHealthUnit: number;
    public idTechnicalManager: number;
    public invoiceNumber: number;
    public idLocations: number[] = [];

    public dateExpiration: Date;
    public dateTimeInclusion: Date;

    public isDeleted: boolean;

    public technicalManagerName: string;
    public crf: string;
    public locationsName: string;
    public invoiceXml: string;
    public invoiceNfeBase64: string;
    public supplier: string;
    public invoiceXmlUserFileName: string;
}